// src/scripts/authGate.js

import {
  auth,
  db,
} from "@/firebase";

import {
  doc,
  getDoc,
} from "firebase/firestore";

import {
  signOut,
} from "firebase/auth";

/**
 * CoreDeck allowlist gate.
 *
 * A Firebase Auth user must also have:
 *
 * users/{uid}
 *
 * in Firestore.
 */
export async function assertUserIsAllowed(
  user
) {
  if (!user?.uid) {
    throw new Error(
      "Not signed in."
    );
  }

  const uid =
    String(
      user.uid || ""
    ).trim();

  const email =
    String(
      user.email || ""
    )
      .trim()
      .toLowerCase();

  console.log(
    "[authGate] Checking signed-in user",
    {
      uid,
      email,
    }
  );

  const ref =
    doc(
      db,
      "users",
      uid
    );

  let snap;

  try {
    snap =
      await getDoc(ref);
  } catch (e) {
    console.error(
      "[authGate] Failed to read users/{uid}",
      {
        uid,
        email,
        code:
          e?.code,
        message:
          e?.message,
        raw:
          e,
      }
    );

    throw new Error(
      [
        "Permission denied while reading your user profile.",
        "",
        `UID: ${uid}`,
        email
          ? `Email: ${email}`
          : "",
        "",
        "Expected Firestore document:",
        `users/${uid}`,
        "",
        "Your Firestore rules must allow the authenticated user to read their own users/{uid} document.",
      ]
        .filter(Boolean)
        .join("\n")
    );
  }

  if (!snap.exists()) {
    console.warn(
      "[authGate] User profile does not exist",
      {
        uid,
        email,
        expectedPath:
          `users/${uid}`,
      }
    );

    try {
      await signOut(auth);
    } catch {
      // no-op
    }

    throw new Error(
      [
        "Access denied. Your account is not authorised for this system.",
        "",
        "No user profile was found at:",
        `users/${uid}`,
      ].join("\n")
    );
  }

  const data =
    snap.data() || {};

  console.log(
    "[authGate] User profile loaded",
    {
      uid,
      email,
      role:
        data.role || "",
      user_type:
        data.user_type ||
        data.userType ||
        "",
      isOperations:
        data.isOperations === true,
      isSocialMedia:
        data.isSocialMedia === true,
      venue_id:
        data.venue_id || "",
      activeVenueId:
        data.activeVenueId || "",
      venue_ids:
        Array.isArray(
          data.venue_ids
        )
          ? data.venue_ids
          : [],
      venue_access:
        data.venue_access || {},
      disabled:
        data.disabled === true,
    }
  );

  if (
    data.disabled === true
  ) {
    try {
      await signOut(auth);
    } catch {
      // no-op
    }

    throw new Error(
      "Access denied. Your account has been disabled."
    );
  }

  return data;
}